export default class RSS {
    URL: string = '';
    updateFrequency: string = '30';
}
